import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8579fc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_2 = { style: {"font-size":"20px","font-weight":"700","margin-top":"6px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"12px","line-height":"1","font-size":"14px","color":"rgba(107, 114, 128, 0.8)"} }, " 欢迎使用旺盈合同管理系统 ", -1))
const _hoisted_4 = { style: {"display":"flex","justify-content":"end","align-items":"center"} }
const _hoisted_5 = { class: "statistic-card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"inline-flex","align-items":"center"} }, " 待办事项 ", -1))
const _hoisted_7 = { class: "statistic-footer" }
const _hoisted_8 = { class: "footer-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "完成比例", -1))
const _hoisted_10 = { class: "vo-ft-suc" }

import { useAppStore } from '@/store/app'
import { UserWorkInfoApi } from '@/apis/homes/apis';
import { onMounted, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const appStore = useAppStore()
const UserInfo = appStore.getLoginInfo as LoginInfo

const datas = reactive({
    workInfo: { pedingTotal: 0, finishRatio: '0.00%' }
});

const load = {
    getUserWorkInfo: async () => {
        const { data } = await UserWorkInfoApi()
        datas.workInfo = data ?? { pedingTotal: 0, finishRatio: '0.00%' }
    }
}


onMounted(() => {
    load.getUserWorkInfo()
})


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_statistic = _resolveComponent("el-statistic")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 20,
        justify: "space-between"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xl: 12,
            lg: 12,
            md: 12,
            sm: 24,
            xs: 24
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_2, " 你好，" + _toDisplayString(_unref(UserInfo).user_name), 1),
                  _hoisted_3
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xl: 12,
            lg: 12,
            md: 12,
            sm: 24,
            xs: 24
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_statistic, {
                    value: _unref(datas).workInfo.pedingTotal
                  }, {
                    title: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(datas).workInfo.finishRatio), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})